import React, { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem('pm_cookie_consent')) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    localStorage.setItem('pm_cookie_consent', 'accepted');
    setVisible(false);
  };
  const customize = () => {
    localStorage.setItem('pm_cookie_consent', 'customized');
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm animate-fade-up">
      <div className="max-w-md w-full bg-forest-900 border border-forest-700 shadow-2xl rounded-sm p-7">
        <p className="text-sm text-cream-100/85 leading-relaxed">
          We use cookies and similar technologies to recognise your repeat visits and preferences, to measure the effectiveness of campaigns, and improve our websites. By clicking “Accept All” you consent to the use of cookies.
        </p>
        <div className="mt-5 grid grid-cols-2 gap-3">
          <button onClick={customize} className="bg-cream-50 text-forest-900 py-2.5 text-sm font-medium hover:bg-cream-100 transition-colors">Customize</button>
          <button onClick={accept} className="bg-sage-500 text-forest-900 py-2.5 text-sm font-medium hover:bg-sage-600 transition-colors">Accept All</button>
        </div>
      </div>
    </div>
  );
}
